module.exports = __webpack_public_path__ + "img/2.ba240593.png";